"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
//# sourceMappingURL=IItemScope.js.map